<template>
    <div class="share-location">
        <Button
                title="Fetch current location"
                type="button"
                icon-right="location"
                button-background="dark"
                button-color="light"
                @click.native="askGeoLocation"
        />
        <Button
                subtext="No thanks"
                type="button"
                button-background="light"
                button-color="dark"
                @click.native="$emit('cancel')"
        />
    </div>
</template>

<script>
  import Button from '@/components/partials/Button'
  import geoLocationService from '@/services/GeoLocationService'

  export default {
    name: 'LocationSharing',
    components: {
      Button
    },
    methods: {
      async askGeoLocation () {

        const result = await geoLocationService.getCurrentLocation().then(geoLocation => {
          return {
            latitude: geoLocation.coords.latitude,
            longitude: geoLocation.coords.longitude
          }
        }).catch(
          error => {
            console.log('getCurrentLocation error', error)
            return false
          }
        )

        this.$emit('shareLocation')
      }
    }
  }
</script>
